<template>
  <div class="trangle-btn">
    <span class="text">查看更多</span>
    <div class="icon-container">
      <div class="icon"></div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.trangle-btn {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 140px;
  height: 48px;
  border: 1px solid #1D2129;
  border-radius: 6px;
  cursor: pointer;
  &:hover {
    border-color: #194189;
    span {
      color: #194189;
    }
    .icon-container {
      .icon {
        animation: btnFadeIn 0.2s ease-in-out;
        background-image: url('https://image.zhihuishu.com/zhs_yufa_150820/b2cm/base1/202507/fe207a0f99cb41778f240046e6e39454.png');
      }
    }
  }
  span {
    color: #1D2129;
    font-size: 16px;
    font-weight: 500;
  }
  .icon-container {
    width: 32px;
    height: 32px;
    .icon {
      width: 100%;
      height: 100%;
      background-image: url('https://image.zhihuishu.com/zhs_yufa_150820/b2cm/base1/202507/7d4b70c240b44e8d9844754f33039606.png');
      background-size: 100% 100%;
    }
  }
  @keyframes btnFadeIn {
    0% {
      opacity: 0;
      width: 0;
      height: 100%;
    }
    100% {
      opacity: 1;
      width: 100%;
      height: 100%;
    }
  }
} 
</style>